import {
  isSafeArray,
  PluckItem,
  safeArray,
} from "@/helpers/functions/ArrayHelpers";

export const hasToken = ({ token }) => !!token;
export const GetUser = ({ user }) => user;

export const existsRole = ({ user }) => {
  const roles = PluckItem(user?.roles, "name");

  return (role = "") =>
    isSafeArray(role)
      ? safeArray(role).every((role) => roles.includes(role))
      : roles.includes(role);
};
